import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  heroStartCalculationLinkWrapper: {
    textDecoration: 'none'
  },

  heroStartCalculationButton: {
    marginTop: 20,
    textDecoration: 'none'
  }
})

export default useStyles